import { type CommonAction, success } from "@iflyrpa/share";
import { z } from "zod";
import { ActionCommonParamsSchema } from "../../types";
import { handleBaijiahaoData } from "./handleBjhData";
import { handleToutiaoData } from "./handleTTData";
import { handleWeixinData } from "./handleWXData";
import { handleXiaohongshuData } from "./handleXhsData";
import type { FetchArticlesData } from "./types";
// 请求参数接口

export const FetchArticlesParamsSchema = ActionCommonParamsSchema.extend({
    platform: z.string().describe("社交平台：weixin, toutiao, baijiahao, xiaohongshu"),
    token: z.union([z.string(), z.number()]).optional().describe("微信和百家号需要"),
    pageNum: z.number().optional().describe("当前页，默认1"),
    pageSize: z.number().optional().describe("每页大小，默认10"),
    size: z.number().optional().describe("获取前多少篇文章（不含草稿），默认获取全部"),
    onlySuccess: z.boolean().optional().describe("是否仅获取发布成功的文章，默认false"),
    showOriginalData: z.boolean().optional().describe("是否展示原始数据，默认false"),
    cursor: z.number().optional().describe("仅用于微信分页游标，默认为空"),
    lastPage: z.number().optional(),
    containsArticle: z.boolean().optional().describe("是否包含文章内容，默认false"),
});

export type FetchArticlesParams = z.infer<typeof FetchArticlesParamsSchema>;

export const FetchArticles: CommonAction<FetchArticlesParams, FetchArticlesData | Record<string, never>> = async (
    _task,
    params,
) => {
    const { platform } = params;
    switch (platform) {
        case "toutiao":
            return handleToutiaoData(_task, params);
        case "weixin":
            return handleWeixinData(_task, params);
        case "baijiahao":
            return handleBaijiahaoData(_task, params);
        case "xiaohongshu":
            return handleXiaohongshuData(_task, params);
        default:
            return success({}, "暂不支持该平台");
    }
};
